import React, { useRef } from 'react';
import { getPercentageHelper } from 'src/helpers/getPercentageHelper';
import { useSubscriptionProgressBarGradient } from 'src/hooks/useSubscriptionProgressBar';
import { clsx } from 'clsx';

export const RepliesLine = ({
  generalPlan,
  color = '#05050D',
  progressLineClassName = undefined,
  progressLineContainerClassName = undefined,
}: {
  generalPlan?: any;
  color?: string;
  progressLineClassName?: any;
  progressLineContainerClassName?: any;
}) => {
  const planRequestLimit =
    generalPlan?.custom_plan_settings?.request_limit || generalPlan?.plan?.request_limit;

  const generalPlanRequestLimit = generalPlan?.request_limit;

  const progressRef = useRef(null);

  const metaData = generalPlan?.meta_data?.usage_by_products;

  const coAgent = metaData?.coagent?.by_source || 0;
  const coBi = metaData?.cobi?.by_source || 0;
  const coCustomer = metaData?.cocustomer?.by_source || 0;

  const generalPercent = getPercentageHelper(
    coAgent + coBi + coCustomer + generalPlan?.credits_count,
    planRequestLimit,
  );

  const extraGeneralPercentage = generalPercent > 100 && generalPercent - 100;

  useSubscriptionProgressBarGradient({
    progressRef,
    bgColor: extraGeneralPercentage ? '#C11A45' : color,
    widthGap: '4px',
    inverse: true,
  });

  const rawUsedRequests =
    Number(planRequestLimit) - Number(generalPlanRequestLimit) + Number(generalPlan?.credits_count);
  const usedRequests = Number.isNaN(rawUsedRequests) ? 0 : rawUsedRequests;

  return (
    <div className="w-full h-full flex flex-col gap-1">
      <div
        className={clsx(
          progressLineContainerClassName,
          extraGeneralPercentage ? 'bg-[#C11A451A]' : 'bg-[#05050D1A]',
          'h-2 min-h-2 w-full rounded-full p-[2px] relative overflow-hidden flex items-center',
        )}
      >
        <div
          ref={progressRef}
          className={clsx(
            progressLineClassName,
            'w-[calc(100%-4px)] h-[calc(100%-4px)] absolute z-0 bg-ebony rounded-full',
          )}
        />
      </div>
      <div className="w-full h-full flex justify-between items-center z-30">
        {extraGeneralPercentage ? (
          <p className="text-[#C11A45]">
            <span className="font-medium text-xs">You are using</span>{' '}
            <span className="font-bold text-xs">extra replies</span>{' '}
            <span className="font-medium text-xs">now</span>
          </p>
        ) : (
          <p className={`text-[${color}]`}>
            <span className="font-bold text-xs">{generalPlanRequestLimit}</span>{' '}
            <span className="font-medium text-xs">Replies Left</span>
          </p>
        )}
        {extraGeneralPercentage ? (
          <p className="text-[#C11A45] opacity-30">
            <span className="font-bold text-xs">
              {usedRequests} / {planRequestLimit}
            </span>
            <span className="font-medium text-xs"> Replies Used</span>
          </p>
        ) : (
          <p className={`opacity-40 text-[${color}]`}>
            <span className="font-bold text-xs">{usedRequests}</span>{' '}
            <span className="font-medium text-xs"> Replies Used </span>
          </p>
        )}
      </div>
    </div>
  );
};
